// src/pages/LoginPage.jsx
import { useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import { useNavigate } from 'react-router-dom';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate  = useNavigate();
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      setError('Email o password non corretti.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        
        <div style={{textAlign:'center',margin:'16px 0'}}><img src="/garagememo-logo.svg" alt="GarageMemo" style={{height:'80px'}} /></div>
        <p style={styles.sub}>La tua collezione sempre con te</p>

        <form onSubmit={handleSubmit} style={styles.form}>
          <label style={styles.label}>Email</label>
          <input
            style={styles.input}
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="nome@email.it"
            required
            autoFocus
          />
          <label style={styles.label}>Password</label>
          <input
            style={styles.input}
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            placeholder="••••••••"
            required
          />
          {error && <p style={styles.error}>{error}</p>}
          <button
            type="submit"
            style={{ ...styles.btn, opacity: loading ? 0.7 : 1 }}
            disabled={loading}
          >
            {loading ? 'Accesso…' : 'Accedi'}
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#f5f4f0',
    fontFamily: "'Georgia', serif",
  },
  card: {
    background: '#fff',
    borderRadius: 20,
    padding: '48px 40px',
    width: '100%',
    maxWidth: 400,
    boxShadow: '0 4px 40px rgba(0,0,0,0.08)',
    textAlign: 'center',
  },
  logo:  { fontSize: 48, marginBottom: 12 },
  title: { fontSize: 28, fontWeight: 600, margin: '0 0 4px', color: '#1a1a1a' },
  sub:   { fontSize: 15, color: '#888', marginBottom: 32 },
  form:  { textAlign: 'left' },
  label: { display: 'block', fontSize: 13, fontWeight: 500, color: '#555', marginBottom: 6, marginTop: 16 },
  input: {
    width: '100%', padding: '12px 14px', fontSize: 16,
    border: '1.5px solid #e0e0e0', borderRadius: 10,
    outline: 'none', fontFamily: 'inherit', boxSizing: 'border-box',
    background: '#fafafa', color: '#1a1a1a',
  },
  btn: {
    width: '100%', padding: '14px', marginTop: 24,
    background: '#1a1a1a', color: '#fff', border: 'none',
    borderRadius: 10, fontSize: 16, fontWeight: 600,
    cursor: 'pointer', fontFamily: 'inherit',
  },
  error: { color: '#d32f2f', fontSize: 14, marginTop: 8, textAlign: 'center' },
};
